/**
 * @returns {string}
 */
export const GET_USER_SUB_ORDERS = () =>
  "/control/getUserSubOrderDetails?allDetails=Y&viewSize=40&viewIndex=0&selfHelp=Y";

/**
 * @param {string} orderId
 * @returns {string}
 */
export const REMOVE_EXPIRED_ORDER = (orderId) => `/control/remove-myorder?orderId=${orderId}`;

/**
 * @param {string} subOrderId
 * @returns {string}
 */
export const HIDE_USER_SUB_ORDER = (subOrderId) => `/control/hideUserSubOrder?subOrderId=${subOrderId}`;

/**
 * @param {string} orderId
 * @returns {string}
 */
export const GET_ORDER_PAYMENT_STATUS = (orderId) => `/control/getOrderPaymentPreferenceStatus?orderId=${orderId}`;

/**
 * @param {string} subOrderId
 * @returns {string}
 */
export const GET_SENDER_MOBILE_COUNTRY = (subOrderId) =>
  `/control/getSenderMobileCountryCodeAndCity?subOrderId=${subOrderId}`;

/**
 * @returns {string}
 */
export const GET_CUST_COMM_PREF = () => "/control/getCustCommPref";

/**
 * @returns {string}
 */
export const UPDATE_CUST_COMM_PREF = () => "/control/updateCustCommPref";

/**
 * @returns {string}
 */
export const GET_PARTNER_LOYALTY_CONTENT = () => "/control/getContentIdDetails?contentId=FNP_PARTNER_LOYALTY";

/**
 * @returns {string}
 */
export const GET_ACCOUNT_SAVED_ADDRESSES = () => "/control/getSavedRecipientAddresses?viewSize=40&viewIndex=0";

/**
 * @returns {string}
 */
export const UPDATE_ACCOUNT_ADDRESS = () => "/control/update-address-rj";

/**
 * @param {string} contactMechId
 * @returns {string}
 */
export const GET_EDIT_SAVED_ADDRESS = (contactMechId) =>
  `/control/getSavedAddressForPincode-rj?fma=Y&contactMechId=${contactMechId}`;

/**
 * @param {string} cartIndex
 * @param {string} contactMechId
 * @returns {string}
 */
export const DELETE_ACCOUNT_ADDRESS = (cartIndex, contactMechId) =>
  `/control/deleteItemAddress-rj?cartItemIndex=${cartIndex}&contactMechId=${contactMechId}`;

export const CMS_CHATBOT_CONFIG = "/global/static/web/chatbot_config";

export const CMS_MY_ACCOUNT_PARTNERS = "/global/static/partners/my-account-partners";

/**
 * @returns {string}
 */
export const ORDER_UPDATE_MESSAGE = () => "/control/orderUpdateMessage";

/**
 * @returns {string}
 */
export const ORDER_UPDATE_SENDER_DETAILS = () => "/control/orderUpdateSenderDetails";

/**
 * @returns {string}
 */
export const ORDER_EDIT_SHIPPING_ADDRESS = () => "/control/orderEditshippingAddress";

/**
 * @returns {string}
 */
export const GET_CUSTOMER_PROFILE_DETAILS = () => "/control/customerProfileDetails";

/**
 * @returns {string}
 */
export const UPDATE_CUSTOMER_PROFILE = () => "/control/profile-rj";

/**
 * @returns {string}
 */
export const GET_GIFT_COUPONS = () => "/control/getGiftCoupons?allCoupons=Y";

/**
 * @param {number} page
 * @param {number} viewSize
 * @returns {string}
 */
export const GET_WALLET_STATEMENT = (page, viewSize = 40) => `/control/gws?page=${page}&viewSize=${viewSize}`;
